/* eslint-disable react/jsx-indent */
import React, { FC, ReactNode } from 'react';
import { Typography700 } from 'views/rebranded-module/common/components';
import Typography500 from 'views/common/components/UI/Typography500';
import { Box } from '@mui/material';
interface InformationItemProps {
  icon: ReactNode;
  title: string;
  details: string | number;
  titleOnSeparateLine?: boolean;
}

const DealInformationItem: FC<InformationItemProps> = (props) => {
  const { icon, title, details, titleOnSeparateLine } = props;

  return (
    <Box display="flex" >
      {icon}
      <Box display="flex" flexWrap="wrap" flexDirection={titleOnSeparateLine? 'column': 'row'}>
        <Typography500
          variant="body2"
          component="span"
          color="text.secondary"
          pl={0.5}
          pr={1}>
          {title}
        </Typography500>

        <Typography700 variant="body2" component="span">
          {details}
        </Typography700>
      </Box>
    </Box>
  );
};

export { DealInformationItem };
